export enum EnumRetailerType {
  R1 = 'R1',
  R2 = 'R2',
}

export enum EnumRetailerStatus {
  ACTIVE = 'terverifikasi', // todo: should be 'active' as its in response
}
